import React from "react";

const Announcement = ({label}) => {
  return (
    <div className="h-[30px] bg-[#ffba24] w-full flex justify-center items-center text-center px-4">
      <p className="uppercase font-semibold text-[14px] lg:text-[16px] 2xl:text-[18px] whitespace-nowrap">
          {label}    
      </p>
    </div>
  );
};

export default Announcement;
